import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { Grid2 } from "@mui/material";
import axios from "axios";
import { XMLParser } from "fast-xml-parser";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};

let regions = ["ne", "cat", "phx", "tcuv"];
let series = [];

function SeriesAPI(mode) {
	const [focusRegion, setFocusRegion] = React.useState("");
	const [focusSeries, setFocusSeries] = React.useState("");
	const [focusSeriesInfo, setFocusSeriesInfo] = React.useState("");

	const [serieAPI, setSeriesAPI] = React.useState([]);

	const [regionJSON, setRegionJSON] = React.useState([]);

	React.useEffect(() => {
		if (focusRegion) {
			loadSeriesAPI();
		}
	}, [focusRegion]);
	React.useEffect(() => {
		if (focusSeries) {
			loadSeriesInfoFile();
		}
	}, [focusSeries]);
	async function loadSeriesInfoFile() {
		//location of the series info file https://cdn.flashtalking.com/feeds/tcaa/ad_services/secured/imageservice/3/${focusSeries.ToyotaAPIName}/${focusSeries.modelyear}/info.json
		/*
            {"le":{"colors":["218","8x8","089","040","3t3","1f7","1k3","1l7"],"colors_included":["218","8x8","040","1f7","1k3","1l7"]},"se":{"colors":["218","2ye","8x8","089","040","3t3","1f7","1k3","1l7","2ra","2ps","2ue","2yd","2uf","2yc"],"colors_included":["218","8x8","040","1f7","1k3","1l7"]},"fx":{"colors":["218","2ye","2ue"],"colors_included":["218"]},"xse":{"colors":["218","2ye","8x8","089","040","3t3","1f7","1k3","1l7","2ra","2ps","2ue","2yd","2uf","2yc"],"colors_included":["218","8x8","040","1f7","1k3","1l7"],"gradePreferred":true},"hybridle":{"colors":["218","8x8","089","040","3t3","1f7","1k3","1l7"],"colors_included":["218","8x8","040","1f7","1k3","1l7"]},"hybridse":{"colors":["218","8x8","089","040","3t3","1f7","1k3","1l7"],"colors_included":["218","8x8","040","1f7","1k3","1l7"]},"hybridxle":{"colors":["218","8x8","089","040","3t3","1f7","1k3","1l7"],"colors_included":["218","8x8","040","1f7","1k3","1l7"]}}
            */
		const response = await fetch(
			`https://cdn.flashtalking.com/feeds/tcaa/ad_services/secured/imageservice/3/${focusSeries.ToyotaAPIName}/${focusSeries.modelyear}/info.json`
		);
		var data = await response.json();
		// data = data.filter((item) => item.status !== "paused");

		setFocusSeriesInfo(data);
		console.log(data);
	}
	// React.useEffect(() => {
	// 	console.log("regionJSON updated");
	// 	console.log(regionJSON);
	// 	if (focusSeries) {
	// 		console.log("running offer data");
	// 		getOfferData();
	// 	}
	// }, [regionJSON]);

	async function loadSeriesAPI() {
		/*
        {
		"seriesname": "4Runner",
		"ToyotaAPIName": "4runner",
		"modelyear": "2025",
		"grade": "limited",
		"color": "8x0",
		"status": "live",
		"group": ["suv"]
	},
	{
		"seriesname": "4Runner i-FORCE MAX",
		"ToyotaAPIName": "4runnerhybrid",
		"modelyear": "2025",
		"grade": "limitedi-forcemax",
		"color": "1l7",
		"status": "live",
		"group": ["suv", "electrified"]
	},
	{
		"seriesname": "bZ4X",
		"ToyotaAPIName": "bz4x",
		"modelyear": "2025",
		"grade": "limited",
		"color": "202",
		"redirected": "RAV4",
		"status": "paused",
		"group": ["suv", "electrified", "popular"]
	}
    ]
    */
		const response = await fetch(
			`https://cdn.flashtalking.com/feeds/tcaa/ad_services/secured/seriesapi/full/${focusRegion}/seriesapi.json`
		);
		var data = await response.json();
		// data = data.filter((item) => item.status !== "paused");

		setSeriesAPI(data);
		console.log(series);
	}

	const [modalOpen, setModalOpen] = React.useState(false);
	const [selectedSeries, setSelectedSeries] = React.useState(null);

	const handleCardClick = (item) => {
		setSelectedSeries(item);
		setModalOpen(true);
		setFocusSeries(item);
	};

	const handleCloseModal = () => {
		setModalOpen(false);
		setSelectedSeries(null);
	};

	return (
		<div id="htmlPage" style={{ textAlign: "left" }}>
			<h1 style={{ display: "flex", alignItems: "center" }}>
				Series API
				<a
					href="https://docs.google.com/document/d/1kcYqOWTtVoHZcEk6kDP2f0IiTVTZHH7doRehdlL8NQ4/edit?tab=t.0"
					target="_blank"
					style={{
						textDecoration: "none",
						fontSize: "12px",
						paddingLeft: "15px",
						color: "red"
					}}
				>
					view release schedule
				</a>
			</h1>

			<Grid2 container spacing={2} direction="column">
				<FormControl sx={{ m: 1, width: 300 }}>
					<InputLabel id="region-select-label">Region</InputLabel>
					<Select
						labelId="region-select-label"
						id="region-select"
						value={focusRegion ? focusRegion : ""}
						onChange={(e) => setFocusRegion(e.target.value)}
						input={<OutlinedInput label="Region" />}
						MenuProps={MenuProps}
					>
						{regions.map((region) => (
							<MenuItem key={region} value={region}>
								<ListItemText primary={region} />
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</Grid2>
			<Grid2 container spacing={2} id="ads">
				{focusRegion &&
					serieAPI.length > 0 &&
					serieAPI.map((item, idx) => (
						<Grid2 item xs={12} sm={6} md={4} key={idx}>
							<div
								style={{
									border: "1px solid #ccc",
									padding: "16px",
									borderRadius: "8px",
									textAlign: "left",
									cursor: "pointer",
									color: item.status == "paused" ? "#d78484" : "inherit"
								}}
								onClick={() => handleCardClick(item)}
							>
								<h3>{item.seriesname}</h3>
								<hr />
								<p>
									<strong>Series Code:</strong> {item.ToyotaAPIName}
								</p>
								<p>
									<strong>Model Year:</strong> {item.modelyear}
								</p>
								<p>
									<strong>Grade:</strong> {item.grade}
								</p>
								<p>
									<strong>Color:</strong> {item.color}
								</p>
								<p>
									<strong>Status:</strong> {item.status}
								</p>
								{item.group && (
									<p>
										<strong>Group:</strong> {item.group.join(", ")}
									</p>
								)}
								{item.redirected && (
									<p>
										<strong>Redirected:</strong> {item.redirected}
									</p>
								)}
							</div>
						</Grid2>
					))}
			</Grid2>
			{modalOpen && selectedSeries && (
				<div
					style={{
						position: "fixed",
						top: 0,
						left: 0,
						width: "100vw",
						height: "100vh",
						background: "rgba(0,0,0,0.5)",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						zIndex: 9999
					}}
					onClick={handleCloseModal}
				>
					<div
						style={{
							background: "#000",
							padding: "32px",
							borderRadius: "12px",
							minWidth: "300px",
							maxWidth: "90vw",
							textAlign: "left",
							position: "relative",
							border: "1px solid #ccc"
						}}
						onClick={(e) => e.stopPropagation()}
					>
						<button
							style={{
								position: "absolute",
								top: 8,
								right: 8,
								color: selectedSeries.status ? "red" : "inherit",
								border: "none",
								fontSize: "1.5rem",
								cursor: "pointer"
							}}
							onClick={handleCloseModal}
						>
							&times;
						</button>
						<h2>{selectedSeries.seriesname}</h2>
						<hr />
						<p>
							<strong>Model Year:</strong> {selectedSeries.modelyear}
						</p>
						<p>
							<strong>Grade:</strong>
							{selectedSeries.grade}
						</p>
						<p>
							<strong>Color:</strong> {selectedSeries.color}
						</p>
						<p>
							<strong>Status:</strong> {selectedSeries.status}
						</p>
						{selectedSeries.group && (
							<p>
								<strong>Group:</strong> {selectedSeries.group.join(", ")}
							</p>
						)}
						{selectedSeries.redirected && (
							<p>
								<strong>Redirected:</strong> {selectedSeries.redirected}
							</p>
						)}
						{/* Images for all angles */}
						<div style={{ marginTop: "24px" }}>
							<h3>Images</h3>
							<div
								style={{
									display: "flex",
									gap: "12px",
									flexWrap: "wrap",
									color: "#000"
								}}
							>
								{[1, 2, 3, 4].map((angle) => (
									<div key={angle} style={{ textAlign: "center" }}>
										<img
											src={`https://cdn.flashtalking.com/feeds/tcaa/ad_services/secured/imageservice/3/${selectedSeries.ToyotaAPIName}/${selectedSeries.modelyear}/${selectedSeries.grade}/${selectedSeries.color}/${angle}/500.webp`}
											alt={`Angle ${angle}`}
											style={{
												height: "120px",
												borderRadius: "8px",
												border: "1px solid #ccc",
												background: "#000",
												cursor: "pointer"
											}}
											onClick={() =>
												window.open(
													`https://cdn.flashtalking.com/feeds/tcaa/ad_services/secured/imageservice/3/${selectedSeries.ToyotaAPIName}/${selectedSeries.modelyear}/${selectedSeries.grade}/${selectedSeries.color}/${angle}/image.webp`,
													"_blank"
												)
											}
										/>
										<div>Angle {angle}</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}

export default SeriesAPI;
